import type { ComponentType, ReactNode } from 'react';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface FormAccordionItemProps {
  value: string;
  icon: ComponentType<{ className?: string }>;
  title: string;
  description: string;
  children: ReactNode;
}

/**
 * One collapsible group of a record form — the icon + title + description
 * header the employee form's accordion items use (`user-edit-form.tsx`).
 * Shared so the customer form and the customer-contact sheet group their
 * fields the same way instead of each hand-rolling a `<fieldset>`. Render
 * inside an `<Accordion type="multiple">`.
 */
export function FormAccordionItem({
  value,
  icon: Icon,
  title,
  description,
  children,
}: FormAccordionItemProps) {
  return (
    <AccordionItem value={value}>
      <AccordionTrigger>
        <div className="flex items-center gap-3">
          <Icon className="size-4 shrink-0 text-muted-foreground" />
          <div>
            <div className="text-sm font-semibold">{title}</div>
            <div className="text-xs text-muted-foreground">{description}</div>
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent className="space-y-3">{children}</AccordionContent>
    </AccordionItem>
  );
}
